import { BRAND_NAME } from "@/lib/brand"
import { cn } from "@/lib/utils"

type TLogoProps = {
  size?: "sm" | "md" | "lg"
}

export function Logo({ size }: TLogoProps = { size: "md" }) {
  return (
    <div className="flex gap-2 items-center">
      <img
        src="/icon.svg"
        alt={`${BRAND_NAME} Icone`}
        className={cn(
          size === "sm" && "h-4 w-4",
          size === "md" || (!size && "h-6 w-6"),
          size === "lg" && "h-8 w-8",
        )}
      />
      <strong
        className={cn(
          size === "sm" && "text-sm",
          size === "md" || (!size && "text-base"),
          size === "lg" && "text-lg",
        )}
      >
        {BRAND_NAME}
      </strong>
    </div>
  )
}
